<template>
<svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z" :stroke="border_color" :stroke-width="stroke_width" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.9998 6.33301L7.33317 9.88856L5.6665 8.2724" stroke="#33BDA3" :stroke-width="stroke_width*0.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
    props:{
        size:{
            default: '16'
        },
        border_color:{
            default:'#008269'
        },
        stroke_width:{
            default:'1.5'
        }
    }
}
</script>


<style>

</style>
